import React from 'react';
import { graphql } from 'gatsby';

import Layout from '../components/Layout';
import Header from '../sections/Header';
import Benefits from '../sections/Benefits';
import HowItWorks from '../sections/HowItWorks';
import MoreAboutTempoAndBenefits from '../sections/MoreAboutTempoAndBenefits';
import { Banners } from '../sections/ActionCards';
import Carousel from '../sections/Carousel';
import { navRoutes } from '../constants';
import { OurNationalSpendNetwork } from '../sections/Logos';
import { ImpactAndUpdatesSection } from '../sections/CardsSections';
import { GeneralCardsSection } from '../sections/Cards';

import placeholderData from '../utils/placeholderData';

export const SpendPartnerLandingTemplate = ({
  headerTitle = 'header title...',
  headerDescription = 'header description...',
  benefitsTitle = 'benefits title...',
  benefits = [],
  testimonials = [],
  nationalNetworkTitle = 'National Network Title...',
  nationalNetworkDescription = 'National Network Description...',
  preview,
  impactAndUpdatePostsTitle = 'Impact And Update Posts Title...',
  moreAboutTempoTitle = 'More About Tempo Title...',
  moreAboutTempoDescription = 'More About Tempo Description',
}) => {
  const benefitsItems = Object.keys(benefits).map(i => benefits[i]);
  const testimonials1 = testimonials.map(testimonial =>
    testimonial ? testimonial.testimonialItem : {},
  );

  return (
    <>
      <Header page="spendPartnerHome" title={headerTitle} subtitle={headerDescription} />
      <HowItWorks page="spendPartnerHome" title="How does it work?" />
      <Benefits title={benefitsTitle} items={benefitsItems} />
      <Banners type="spendPartner1" />
      <Carousel data={testimonials1} />
      <OurNationalSpendNetwork
        title={nationalNetworkTitle}
        description={nationalNetworkDescription}
      />
      {preview ? (
        <GeneralCardsSection
          data={placeholderData}
          type="impacts"
          title={impactAndUpdatePostsTitle || 'Impact & updates'}
        />
      ) : (
        <ImpactAndUpdatesSection title={impactAndUpdatePostsTitle} type="impacts" bgcolor="gray2" />
      )}
      <MoreAboutTempoAndBenefits
        title={moreAboutTempoTitle}
        description={moreAboutTempoDescription}
        to={navRoutes.aboutUs}
      />
      <Banners type="spendPartner2" />
    </>
  );
};

const SpendPartnersLandingPage = ({
  data: {
    markdownRemark: { frontmatter },
  },
}) => {
  return (
    <Layout>
      <SpendPartnerLandingTemplate {...frontmatter} />
    </Layout>
  );
};

export const SpendPartnerQuery = graphql`
  query SpendPartnerQuery($id: String!) {
    markdownRemark(id: { eq: $id }) {
      frontmatter {
        headerTitle
        headerDescription
        benefitsTitle
        benefits {
          firstItem {
            title
            description
          }
          secondItem {
            title
            description
          }
          thirdItem {
            title
            description
          }
          fourthItem {
            title
            description
          }
        }
        testimonials {
          testimonialItem {
            content
            author
            location
          }
        }
        nationalNetworkTitle
        nationalNetworkDescription
        impactAndUpdatePostsTitle
        moreAboutTempoTitle
        moreAboutTempoDescription
      }
    }
  }
`;

export default SpendPartnersLandingPage;
